import { DateInput as MantineDateInput, type DateInputProps } from '@mantine/dates';

export const DateInput = ({ size = 'xs', ...props }: DateInputProps) => {
    return <MantineDateInput size={size} {...props} valueFormat="DD.MM.YYYY" />;
};
